export enum ContractStatusEnum {
  RenewalRequest = 'Renewal Request',
  NotCompleted = 'not completed',
  TerminationRequested = 'Termination requested',
  Archived = 'Archived',
  ExpiringSoon = 'expiring soon',
  Signed = 'signed',
  Empty = 'empty',
}

interface StatusConfig {
  text: string;
  className: string;
}

const statusMap: Record<
  Exclude<ContractStatusEnum, ContractStatusEnum.Empty>,
  StatusConfig
> = {
  [ContractStatusEnum.RenewalRequest]: {
    text: 'درخواست تمدید',
    className: 'text-amber-600 ',
  },
  [ContractStatusEnum.NotCompleted]: {
    text: 'تکمیل نشده',
    className: 'text-red-600',
  },
  [ContractStatusEnum.TerminationRequested]: {
    text: 'درخواست فسخ',
    className: 'text-orange-600  ',
  },
  [ContractStatusEnum.Archived]: {
    text: 'قرارداد منقضی شده',
    className: 'text-red-600  ',
  },
  [ContractStatusEnum.ExpiringSoon]: {
    text: 'در حال انقضا',
    className: 'text-orange-600 ',
  },
  [ContractStatusEnum.Signed]: {
    text: 'قرارداد امضا شده',
    className: 'text-farm-shop-400 ',
  },
};

interface SignStatusBadgeProps {
  status: string;
}

const SignStatusBadge = ({status}: SignStatusBadgeProps) => {
  const statusEnum = status as ContractStatusEnum;

  if (statusEnum === ContractStatusEnum.Empty || !statusMap[statusEnum]) {
    return null;
  }

  const {text, className} = statusMap[statusEnum];

  return (
    <span className={`text-sm flex justify-center items-center ${className}`}>
      {text}
    </span>
  );
};

export default SignStatusBadge;
